module.exports = __webpack_public_path__ + "media/bootstrap-icons/wallet-e47a1af9.svg";